import { isMobile } from 'react-device-detect';

const TOPBAR_HEIGHT = isMobile ? 48 : 64;
const FOOTER_HEIGHT = isMobile ? 98 : 257;
const LOADER_HEIGHT = 50;
export const IMG_SIZE_XS = 16;
export const CONTENT_HEIGHT = `calc(100vh - ${TOPBAR_HEIGHT +
  FOOTER_HEIGHT +
  LOADER_HEIGHT}px)`;
